export default "__VITE_ASSET__5b993ef7__"